﻿export function formsPostcode() {
  var AddressLookup = {
    quickSearchUrl: '/umbraco/api/AddressLookup/QuickSearch',
    postcodeLookupUrl: '/umbraco/api/AddressLookup/ContainerSearch',
    addressLookupUrl: '/umbraco/api/AddressLookup/AddressLookup',

    /*
     * Returns a list of results from a {partial} postcode / address search
     *
     * AddressLookup.postcodeSearch('GB|AB|ENG|HR4_7EX')
     *
     * */
    //postcodeSearch: function (searchTerm, callback, error) {
    //  Http.post({
    //    'url': this.quickSearchUrl,
    //    'data': {
    //      'q': searchTerm
    //    },
    //    'success': function (data) {
    //      //console.log(data);
    //      if (callback !== undefined) {
    //        callback(data);
    //      }
    //    },
    //    'error': function (e) {
    //      if (error !== undefined) {
    //        error();
    //      }
    //    }
    //  });
    //  },

    postcodeSearch: function (searchTerm, token, requestId, callback, error, url) {
      Http.post({
        url: url !== undefined ? url : this.quickSearchUrl,
        data: { q: searchTerm, t: token, f: requestId },
        success: function (data) {
          if (callback !== undefined) {
            callback(data);
          }
        },
        error: function (e) {
          if (e.status === 429) {
            window.location.replace('/coveragecheckerror');
          }

          if (error !== undefined) {
            error();
          }
        },
      });
    },

    /*
     * Returns the addresses within a postcode
     * Expects postcodeId arg to be Id attribute returned from postcodeSearch
     *
     * AddressLookup.postcodeLookup('GB|AB|ENG|HR4_7EX')
     *
     */
    //postcodeLookup: function (postcodeId, callback, error) {
    //  Http.post({
    //    'url': this.postcodeLookupUrl,
    //    'data': {
    //      'q': postcodeId
    //    },
    //    'success': function (data) {
    //      //console.log(data);
    //      if (callback !== undefined) {
    //        callback(data);
    //      }
    //    },
    //    'error': function (e) {
    //      if (error !== undefined) {
    //        error(e);
    //      }
    //    }
    //  });
    //  },

    postcodeLookup: function (postcodeId, token, requestId, callback, error, url) {
      Http.post({
        url: url !== undefined ? url : this.postcodeLookupUrl,
        data: { q: postcodeId, t: token, f: requestId },
        success: function (data) {
          if (callback !== undefined) {
            callback(data);
          }
        },
        error: function (e) {
          if (error !== undefined) {
            error(e);
            window.location.replace('/coveragecheckerror');
          }
        },
      });
    },

    /*
     * Returns the address details of a property
     * Expects addressId arg to be the Id attribute returned from postcodeLookup
     *
     * AddressLookup.addressLookup('GB|AB|B|U200002605828')
     *
     */
    addressLookup: function (addressId, callback, error) {
      Http.post({
        url: this.addressLookupUrl,
        data: {
          q: addressId,
        },
        success: function (data) {
          //console.log(data);
          if (callback !== undefined) {
            callback(data);
          }
        },
        error: function (e) {
          if (error !== undefined) {
            error();
          }
        },
      });
    },
  };

  var AddressLookupUI = {
    init: function () {
      this.quickSearchResultsSearchField = document.getElementsByClassName('postcode-form-field');
      this.addEventHandlers();
    },

    lookUpByID: function (id) {
      var self = this;
      //AddressLookup.postcodeLookup(id, self.populatePostcodeResults, console.log)

      const botdPromise = import('../botd').then((Botd) =>
        Botd.load({ publicKey: 'ic5tXb1J2ZGlcEIM0CddkpL0' })
      );

      // Get the bot detection result when you need it.
      // Result will contain the requestId property,
      // that you can securely verify on the server.
      botdPromise
        .then((botd) => botd.detect())
        .then((result) => {
          self.verifyRecaptcha('PostcodeLookup', result.requestId, AddressLookup.postcodeLookup, {
            target: id,
            method: self.populatePostcodeResults,
            url: AddressLookup.postcodeLookupUrl,
          });
        })
        .catch((error) => console.error(error));

      // grecaptcha.ready(function () {
      //     grecaptcha.execute('6LedSTUqAAAAAMke0iqdysHMY2viNEeZXPBenIAX', { action: 'PostcodeLookup' }).then(function (token) {
      //         // Add your logic to submit to your backend server here.
      //         if (token != undefined) {
      //             AddressLookup.postcodeLookup(id, token, self.populatePostcodeResults, console.log)
      //         }
      //     });
      // });
    },

    verifyRecaptcha: function (action, requestId, callback, opts) {
      grecaptcha.ready(function () {
        grecaptcha
          .execute('6LedSTUqAAAAAMke0iqdysHMY2viNEeZXPBenIAX', { action: action })
          .then(function (token) {
            // Add your logic to submit to your backend server here.
            if (token != undefined) {
              callback(opts.target, token, requestId, opts.method, function () {}, opts.url);
            }
          });
      });
    },

    addEventHandlers: function () {
      var self = this;
      for (let qitem of this.quickSearchResultsSearchField) {
        qitem.addEventListener(
          'keyup',
          debounce(function (e) {
            if (e.target.value.length > 0) {
              const botdPromise = import('../botd').then((Botd) =>
                Botd.load({ publicKey: 'ic5tXb1J2ZGlcEIM0CddkpL0' })
              );
              // Get the bot detection result when you need it.
              // Result will contain the requestId property,
              // that you can securely verify on the server.
              botdPromise
                .then((botd) => botd.detect())
                .then((result) => {
                  if (e.target.value.length > 0) {
                    self.verifyRecaptcha(
                      'PostcodeSearch',
                      result.requestId,
                      AddressLookup.postcodeSearch,
                      {
                        target: e.target.value,
                        method: self.populatePostcodeResults,
                        url: AddressLookup.quickSearchUrl,
                      }
                    );
                  }
                })
                .catch((error) => console.error(error));

              // grecaptcha.ready(function () {
              //     grecaptcha.execute('6LedSTUqAAAAAMke0iqdysHMY2viNEeZXPBenIAX', { action: 'PostcodeSearch' }).then(function (token) {
              //         // Add your logic to submit to your backend server here.
              //         if (token != undefined) {
              //             AddressLookup.postcodeSearch(e.target.value, token, AddressLookupUI.populatePostcodeResults);
              //         }
              //     });
              // });
            }

            //AddressLookup.postcodeSearch(e.target.value, AddressLookupUI.populatePostcodeResults);
          }, 1000)
        );
      }
    },

    populatePostcodeResults: function (postcodes) {
      var containers = document.getElementsByClassName('postcode-form-results'); // set results container
      for (let container of containers) {
        var el;
        container.classList.remove('hidden');
        while (container.children.length > 0) {
          // remove results contents
          container.children[0].remove();
        }
        if (postcodes.length === 0) {
          container.classList.add('hidden');
        } else if (postcodes.length === 1 && postcodes[0].Type === 'Postcode') {
          AddressLookupUI.lookUpByID(postcodes[0].Id);
          return;
        }

        postcodes.forEach(function (item) {
          el = document.createElement('div');
          el.innerText = item.Text + ', ' + item.Description;
          el.classList.add('pc-option');
          el.setAttribute('data-description', item.Description);
          el.setAttribute('data-id', item.Id);
          el.setAttribute('data-type', item.Type);
          if (
            item.Type === 'Postcode' ||
            item.Type === 'BuildingNumber' ||
            item.Type === 'Street' ||
            item.Type === 'BuildingName'
          ) {
            el.addEventListener('click', (e) => {
              AddressLookupUI.lookUpByID(item.Id);
            });
          }
          if (item.Type === 'Address') {
            let idArray = item.Id.split('|');
            // let addArray = item.Description.split(",");
            let uID = idArray[idArray.length - 1]; // get last child of array
            uID = uID.replace('U', '');
            // let add2 = addArray[0]; // get first child of array
            // let add3 = addArray[addArray.length - 1]; // get last child of array
            el.addEventListener('click', (e) => {
              // console.log(uID, btoa(uID), item.Text, btoa(item.Text), add2, btoa(add2), add3, btoa(add3));
              // Final
              container.classList.add('hidden');
              document.getElementById('Form_Address_UPRN').value = uID;
              document.getElementById('Form_Address_Street').value = item.Text;
              document.getElementById('Form_Address_LoqateId').value = item.Id;
              document.getElementsByClassName('postcode-form-field')[0].value =
                item.Text + ', ' + item.Description;
            });
          }
          container.appendChild(el);
        });
      }
    },
  };

  // initiate postcode lookup
  if (document.getElementsByClassName('postcode-form-field').length > 0) {
    AddressLookupUI.init();
  }

  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }
}
